import React, { Component } from 'react';
//import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';
import noPlaylist from '../images/no-playlist.png';

import './ManagePlaylistsPage.css';

class ManagePlaylistsPage extends Component {
  componentDidMount(){
    this.props.actions.setTokens(this.props.accessToken, this.props.refreshToken);
    console.log(this.props);
    this.props.actions.getPlaylists(this.props.user.id);
  }

  render() {
    if(!this.props.playlists){
      return (
        <h3>Loading playlists</h3>
      );
    }

    let playlists = this.props.playlists.map((list, index, arr) => {
      let img;
      if(list.images.length){
        img = list.images[0].url;
      }else{
        img = noPlaylist;
      }
      let url = `/playlists/${list.owner.id}/${list.id}`;
      return (
        <div className="playlists" key={list.id}>
        <Link to={url}>
          <img src={img} height="200px" alt="album artwork" />
          <br />
          <div className="playlistName">{list.name}</div>
        </Link>
        </div>
      );
    });

    return (
      <div className="playlists">
        {playlists}
      </div>
    );
  }
}

// ManagePlaylistsPage.propTypes = {
//   //
// };

function mapStateToProps(state, ownProps){
  return {
    playlists: state.playlist.playlists,
    accessToken: state.currentUser.accessToken,
    refreshToken: state.currentUser.refreshToken,
    user: state.currentUser.user
  };
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagePlaylistsPage);


// WEBPACK FOOTER //
// ./src/components/ManagePlaylistsPage.js